import { laptopRatio, mobileRatio, theme } from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

export const sessionNotesStyle = {
  sessionNotes: {
    '& .card-header': {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .notes-actions': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: getResponsiveSize(10),
        '& .reset, .save-btn': {
          p: getResponsiveSize(2),
          '& svg': {
            color: theme.palette.myPrimary.lightBlue70,
            fontSize: getResponsiveSize(24),
            ...theme.palette.propVars.easeInOutTransition,
          },
          '&:hover': {
            '& svg': {
              color: theme.palette.myPrimary.lightBlue100,
            },
          },
        },
        '& .reset:hover svg': {
          transform: 'rotate(-45deg)',
        },
      },
    },
    [theme.breakpoints.media.laptop]: {
      '& .card-header .notes-actions': {
        '& .reset svg, .save-btn svg': {
          fontSize: getResponsiveSize(20, laptopRatio),
        },
      },
      '& .MuiFormControl-root': {
        height: 'unset',
      },
    },
    [theme.breakpoints.media.tableResponsive]: {
      '& .card-header .notes-actions': {
        '& .reset svg, .save-btn svg': {
          fontSize: getResponsiveSize(20, mobileRatio),
        },
      },
    },
  },
};
